import type { Subject } from '@casl/ability';

import {
  Ability,
  AbilityBuilder,
  AbilityTuple,
  MongoAbility,
  MongoQuery,
  createMongoAbility,
} from '@casl/ability';

import { AuthData } from '@/models/auth';

export type AppAbility = Ability<[string, Subject]>;
export type CommonAbility = Ability<AbilityTuple, MongoQuery>;

export function createEmptyAbility(): MongoAbility<AbilityTuple, MongoQuery> {
  const { build } = new AbilityBuilder(createMongoAbility);
  return build();
}

export function updateAbility(ability: AppAbility, authData: AuthData): void {
  const { can, rules } = new AbilityBuilder(createMongoAbility);
  ability.update([]); // took back all permissions
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!authData) return;
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!authData.access || !authData.permissions) return;
  authData.permissions.forEach((permission) => {
    const subject = permission.subject;
    permission.actions.forEach((action) => {
      can(action, subject);
    });
  });
  ability.update(rules);
}
